const overrides = {
  gutterBottom: {
    marginBottom: 8,
  },
};
export default overrides;
